export { default as identity } from './identity'



// WEBPACK FOOTER //
// ./src/themes/default/brand/index.js